module.exports = __webpack_public_path__ + "img/info-circle-red.e86cc050.svg";